import React, { useEffect, useState } from "react";

export default function AttendanceLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const res = await fetch("https://attendance-api.elitewebpro.com/api/attendance/logs");
      const data = await res.json();
      if (data.success) {
        setLogs(data.logs);
      } else {
        setError("Failed to fetch logs");
      }
    } catch (err) {
      console.error(err);
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Copied to clipboard: " + text);
  };

  const deleteLog = async (id) => {
    if (!window.confirm("Are you sure you want to delete this log?")) return;

    try {
      const res = await fetch(`https://attendance-api.elitewebpro.com/api/attendance/logs/${id}`, {
        method: "DELETE",
      });
      const data = await res.json();
      if (data.success) {
        setLogs(logs.filter((log) => log.id !== id));
      } else {
        alert(data.message || "Failed to delete");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  if (loading) return <p>Loading attendance logs...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Attendance Logs</h2>
      <table border="1" cellPadding="8" cellSpacing="0" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Employee</th>
            <th>Status</th>
            <th>Timestamp</th>
            <th>Source</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log) => (
            <tr key={log.id}>
              <td>{log.id}</td>
              <td>
                {log.image_path && (
                  <img
                    src={`https://attendance-api.elitewebpro.com${log.image_path}`}
                    alt={log.name}
                    style={{ width: 30, borderRadius: "50%", marginRight: 5 }}
                  />
                )}
                {log.name} ({log.email})
              </td>
              <td>{log.status}</td>
              <td>{log.timestamp}</td>
              <td>{log.source}</td>
              <td>
                <button onClick={() => copyToClipboard(JSON.stringify(log))} style={{ marginRight: 5 }}>
                  Copy
                </button>
                <button onClick={() => deleteLog(log.id)}>Delete</button>
              </td>
            </tr>
          ))}
          {logs.length === 0 && (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No logs found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
